import React from 'react';
import { Icon } from './Icon.js';
export const IconCoverFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "m13.75,2H4.25c-1.5166,0-2.75,1.2334-2.75,2.75v8.5c0,1.5166,1.2334,2.75,2.75,2.75h9.5c1.5166,0,2.75-1.2334,2.75-2.75V4.75c0-1.5166-1.2334-2.75-2.75-2.75Zm.25,6.25c0,.4141-.3359.75-.75.75H4.75c-.4141,0-.75-.3359-.75-.75v-3c0-.4141.3359-.75.75-.75h8.5c.4141,0,.75.3359.75.75v3Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconCoverFill18.js.map